// extracted by mini-css-extract-plugin
module.exports = {"HowItWorks":"_1ozOcK2WX7uz_K57j47DQV"};